import { WORKFLOW_MODULE_LABELS } from './workflowModules';

/** Canonical workflow module paths */
export const WORKFLOW_ROUTES = {
  askAi: '/ask-ai',
  library: '/terminal/playbook',
  setups: '/terminal',
  scan: '/terminal',
  simulate: '/simulate',
  record: '/terminal/record',
  savedSetup: '/saved-setup',
};

/** Legacy paths that redirect to the rebuild (kept for bookmarks / old links). */
export const LEGACY_REDIRECT_ROUTES = {
  library: '/library',
  myRecord: '/my-record',
  setupsLegacy: '/setups/legacy',
};

/** Legacy paths kept for redirects only */
export const LEGACY_WORKFLOW_ROUTES = {
  hub: '/hub',
  dashboard: '/dashboard',
};

export function viewModeFromPathname(pathname) {
  if (pathname === WORKFLOW_ROUTES.setups) return 'marketpulse';
  if (pathname === WORKFLOW_ROUTES.scan) return 'hybrid';
  return null;
}

export function isLibraryPath(pathname) {
  return pathname === WORKFLOW_ROUTES.library
    || pathname.startsWith('/terminal/playbook')
    || pathname === LEGACY_REDIRECT_ROUTES.library;
}

export function isAskAiPath(pathname) {
  return pathname === WORKFLOW_ROUTES.askAi || pathname === LEGACY_WORKFLOW_ROUTES.hub;
}

export function isSetupsPath(pathname) {
  return pathname === WORKFLOW_ROUTES.setups;
}

export function isScanPath(pathname) {
  return pathname === WORKFLOW_ROUTES.scan || pathname === LEGACY_WORKFLOW_ROUTES.dashboard;
}

export function isWorkflowShellPath(pathname) {
  return [
    WORKFLOW_ROUTES.library,
    WORKFLOW_ROUTES.askAi,
    LEGACY_WORKFLOW_ROUTES.hub,
    WORKFLOW_ROUTES.setups,
    WORKFLOW_ROUTES.scan,
    LEGACY_WORKFLOW_ROUTES.dashboard,
    WORKFLOW_ROUTES.savedSetup,
    WORKFLOW_ROUTES.simulate,
  ].includes(pathname);
}

/** PostHog / pilot analytics module source from path */
export function workflowAnalyticsSource(pathname, search = '') {
  if (isAskAiPath(pathname)) return 'hub';
  if (isSetupsPath(pathname) || search.includes('mode=marketpulse')) return 'pulse';
  return 'radar';
}

export function isModuleActive(moduleId, pathname, searchParams) {
  const mode = searchParams?.get?.('mode');
  if (moduleId === 'library') return isLibraryPath(pathname);
  if (moduleId === 'hub') return isAskAiPath(pathname);
  if (moduleId === 'pulse') {
    return isSetupsPath(pathname)
      || (pathname === LEGACY_WORKFLOW_ROUTES.dashboard && mode === 'marketpulse');
  }
  if (moduleId === 'radar') {
    return pathname === WORKFLOW_ROUTES.scan
      || (pathname === LEGACY_WORKFLOW_ROUTES.dashboard && (mode === 'hybrid' || mode == null || mode === ''));
  }
  if (moduleId === 'simulate') return pathname === WORKFLOW_ROUTES.simulate;
  return false;
}

/** Shared left-rail module definitions */
export const WORKFLOW_NAV_MODULES = [
  { id: 'pulse', label: WORKFLOW_MODULE_LABELS.pulse, path: WORKFLOW_ROUTES.setups },
  // Scan (radar) module retired — Setups is the core surface
  { id: 'simulate', label: WORKFLOW_MODULE_LABELS.simulate, path: WORKFLOW_ROUTES.simulate },
  { id: 'library', label: WORKFLOW_MODULE_LABELS.library, path: WORKFLOW_ROUTES.library },
];
